import axios from '@/libs/api.request'

export const storedValueActivityList = () => {
  return axios.request({
    url: 'stored-value/admin/activities',
    method: 'get',
  })
}

export const storedValueActivityCreate = (data) => {
  return axios.request({
    url: 'stored-value/admin/activities',
    method: 'post',
    data,
  })
}

export const storedValueActivityUpdate = (id, data) => {
  return axios.request({
    url: `stored-value/admin/activities/${id}`,
    method: 'put',
    data,
  })
}

export const storedValueLedgers = (params) => {
  return axios.request({
    url: 'stored-value/admin/ledgers',
    method: 'get',
    params,
  })
}

/** 全量充值/流水（营销-充值记录） */
export const storedValueLedgerReport = (params) => {
  return axios.request({
    url: 'stored-value/admin/ledgers',
    method: 'get',
    params: { all: 1, ...params },
  })
}

export const storedValueRechargeOrders = (params) => {
  return axios.request({
    url: 'stored-value/admin/recharge-orders',
    method: 'get',
    params,
  })
}

export const storedValueAdjust = (data) => {
  return axios.request({
    url: 'stored-value/admin/adjust',
    method: 'post',
    data,
  })
}

export const memberBenefitGet = () => {
  return axios.request({
    url: 'member-benefit/admin/',
    method: 'get',
  })
}

export const memberBenefitSave = (data) => {
  return axios.request({
    url: 'member-benefit/admin/',
    method: 'put',
    data,
  })
}
